import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { CoreFormService } from 'src/app/core/forms/core-forms.service';
import { TaxRatesService } from '../tax-rates.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-tax-rates-detail',
  templateUrl: './tax-rates-detail.component.html',
  styleUrls: ['./tax-rates-detail.component.scss']
})
export class TaxRatesDetailComponent implements OnInit {

  @ViewChild("formDetails") public formDetails: NgForm;
  public taxRate: any = {
    name: ""
  };
  public countries: any[] = [];

  constructor(
    private taxRatesService: TaxRatesService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private coreFormService: CoreFormService,
    private coreDialogService: CoreDialogService,
    private _location: Location
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.loadData(params['id']);
    });
  }

  loadData(id: number) {
    if (id != 0) {
      this.taxRatesService.get(id).subscribe(
        data => {
          this.taxRate = data;
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      );
    }
  }

  cancel() {
    this.router.navigate(['/configuration/taxRates']);
  }

  save() {
    if (this.taxRate.id != null && this.taxRate.id > 0) {
      this.taxRatesService.save(this.taxRate.id, this.taxRate).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: 'success', summary: "IVA modificado correctamente" });
          this.router.navigate(['/configuration/taxRates']);
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      )
    } else {
      this.taxRatesService.add(this.taxRate).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: 'success', summary: "IVA añadido correctamente" });
          this.router.navigate(['/configuration/taxRates']);
        },
        error => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      )
    }
  }

  delete() {
    this.coreDialogService.confirm({
      message: '¿Está seguro de que desea eliminar este IVA?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.taxRatesService.delete(this.taxRate.id).subscribe(
          res => {
            this.messageService.add({ closable: false, severity: 'success', summary: 'IVA eliminado correctamente' });
            this._location.back();
            //this.router.navigate(['/configuration/taxRates']);
          },
          error => {
            this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
          }
        );
      },
      reject: () => {

      }
    });
  }

  isDuplied() {
    var errorMessage = "";
    if (this.taxRate.name.length <= 0) {
      //errorMessage += "El nombre no puede estar vacío. \n";
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "El nombre no puede estar vacío." });
    }
    /*if(errorMessage){
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: errorMessage });
    }*/
    this.taxRatesService.isDuplied(this.taxRate).subscribe(
      data => {
        if (data == true) {
          this.coreDialogService.notify({
            message: "Ya existe una provincia con estos datos proporcionados.",
            header: 'Error',
            icon: 'far exclamation-circle',
            color: 'var(--orange-500)',
            accept: () => { }
          });
        } else {
          this.save();
        }
      }
    );
  }
}
